import { IconProps } from "./types";

export default function IcoBluetooth({
	color = "#4B5563",
	width = "10",
	height = "16"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 10 16"
			fill="none"
		>
			<g clipPath="url(#clip0_641_1114)">
				<path
					d="M6.13955 8.12572L9.03412 4.89656L4.47221 0V6.44781L1.78124 3.75684L0.799805 4.73825L4.17671 8.12572L0.799805 11.5132L1.78124 12.4946L4.47221 9.80363L4.55705 16L9.1993 11.3549L6.13955 8.12572ZM7.41643 4.90709L5.85465 6.46891L5.84409 3.33469L7.41643 4.90709ZM5.85465 9.7825L7.41643 11.3443L5.84409 12.9167L5.85465 9.7825Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_641_1114">
					<path d="M0 0H10V16H0V0Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
